const vueInst = new Vue({
	el: '#vue-wrap',
	data: {
		mid: null,
        page: 1,
        rows: 16,
        totalPage: 1,
		isbig: 1,
		cid: 0,
		allCourseFlag: false,
		courseList: [],
		type: '',
		allTypeFlag: true,
		typeList: [],
		classList: []
	},
	methods: {
		// 获取专业
		getParams: function() {
			this.mid = this.getQueryString('mid') - 0 || 11;
			switch (this.mid) {
				case 1:
				case 2:
                    this.typeList = [
                        {
                            name: '全过程特训(精讲班)',
                            isActive: false
                        },
                        {
                            name: '全过程特训(基础班)',
                            isActive: false
                        },
                        {
                            name: '全过程特训(加强班)',
                            isActive: false
                        },
                    ];
                    break;
				case 11:
                    this.typeList = [
                        {
                            name: '全程服务加强班',
                            isActive: false
                        },
                        {
                            name: '全程服务保障班',
                            isActive: false
                        },
                        {
                            name: '全程服务面授班',
                            isActive: false
                        }
                    ];
                    break;
				case 13:
				case 71:
					this.typeList = [
						{
							name: '全过程特训(基础班)',
							isActive: false
						},
						{
							name: '全过程特训(加强班)',
							isActive: false
						},
						{
							name: '全过程特训(面授班)',
							isActive: false
						},
					];
					break;
				case 10:
				case 64:
				case 65:
				case 67:
				case 70:
					this.typeList = [
						{
							name: '全过程特训(精讲班)',
							isActive: false
						},
						{
							name: '全过程特训(基础班)',
							isActive: false
						},
						{
							name: '全过程特训(加强班)',
							isActive: false
						},
					];
					break;
                case 91:
                    this.typeList = [
                        {
                            name: '全过程特训(精讲班)',
                            isActive: false
                        },
                        {
                            name: '全过程特训(基础班)',
                            isActive: false
                        },
                        {
                            name: '全过程特训(加强班)',
                            isActive: false
                        },
                    ];
                    break;
				default:
					break;
			}
		},
		// 获取科目
		getCourse: function() {
			axios.post(baseURL + 'getCourseByMid?mid=' + this.mid)
				.then(res => {
					if (res.code == 200) {
						res.list.forEach(item => {
							item.isActive = false;
						});
						this.courseList = res.list;
					}
				})
				.catch(err => console.log(err));
		},
		// 获取课程
		getClass: function() {
			axios.post(baseURL + 'getGradeByCid?page=' + this.page + '&rows=' + this.rows + '&mid=' + this.mid + '&cid=' + this.cid + '&isbig=' + this.isbig + '&name=' + this.type)
				.then(res => {
					if (res.code == 200) {
						this.classList = res.list;
                        this.totalPage = Math.ceil(res.total / this.rows);
					}
				})
				.catch(err => console.log(err));
		},
		// 不限科目
		allCourse: function() {
			this.courseList.forEach(item => item.isActive = false);
			this.allCourseFlag = true;
			this.cid = 0;
			this.isbig = 0;
			this.getClass();
		},
		// 全科套餐
		bigCourse: function() {
			this.courseList.forEach(item => item.isActive = false);
			this.allCourseFlag = false;
			this.cid = 0;
			this.isbig = 1;
			this.getClass();
		},
		// 科目筛选
		changeCourse: function(course) {
			this.allCourseFlag = false;
			this.isbig = 0;
			this.courseList.forEach(item => item.isActive = false);
			course.isActive = true;
			this.cid = course.id;
			this.getClass();
		},
		// 不限班级类型
		allType: function() {
			this.typeList.forEach(item => item.isActive = false);
			this.allTypeFlag = true;
			this.type = '';
			this.getClass();
		},
		// 班级类型筛选
		changeType: function(type) {
			this.allTypeFlag = false;
			this.typeList.forEach(item => item.isActive = false);
			type.isActive = true;
			this.type = type.name;
			this.getClass();
		},
		// 跳转详情
		goDetail: function(id) {
			window.open('pages/class/detail.html?id=' + id + '&isBig=' + this.isbig);
		},
		turnPage: function (page) {
			this.page = page;
            this.classList.length = 0;
			this.getClass();
        }
	},
	mounted() {
		this.getParams();
		this.getCourse();
		this.getClass();
	}
});